import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]
  static values = { basePath: String }

  update(event) {
    const type = event.target.value
    if (!this.hasLinkTarget) return
    if (type) {
      this.linkTarget.href = `${this.basePathValue}?type=${type}`
      this.linkTarget.style.display = ""
    } else {
      this.linkTarget.style.display = "none"
    }
  }
}
